import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-系统管理",
  "use": "icon-系统管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-系统管理\">\n<path d=\"M25 14H57.5556C63.6307 14 68.5556 18.9249 68.5556 25V70.1111H25C18.9249 70.1111 14 65.1863 14 59.1111V25C14 18.9249 18.9249 14 25 14Z\" stroke-width=\"10\" />\n<path d=\"M133 144L100.444 144C94.3693 144 89.4444 139.075 89.4444 133L89.4444 87.8889L133 87.8889C139.075 87.8889 144 92.8138 144 98.8889L144 133C144 139.075 139.075 144 133 144Z\" stroke-width=\"10\" />\n<path d=\"M144 25L144 57.5556C144 63.6307 139.075 68.5556 133 68.5556L89.4444 68.5556L89.4444 25C89.4444 18.9249 94.3693 14 100.444 14L133 14C139.075 14 144 18.9249 144 25Z\" stroke-width=\"10\" />\n<path d=\"M14 133L14 100.444C14 94.3693 18.9249 89.4444 25 89.4444L68.5556 89.4445L68.5556 133C68.5556 139.075 63.6307 144 57.5556 144L25 144C18.9249 144 14 139.075 14 133Z\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/系统管理.svg
// module id = 6Sh8
// module chunks = 26